<template>
  <div class="collapse_gruop__wrappers">
    <slot />
  </div>
</template>

<script>
export default {
  props: { visible: { type: Boolean, default: true } },
  data() {
    return { closed: false }
  },
  created() {
    this.closed = !this.visible
  },
  methods: {
    open() {
      this.closed = false
      this.$emit('open')
    },
    close() {
      this.closed = true
      this.$emit('close')
    },
    toggle() {
      this.closed ? this.open() : this.close()
    },
  },
  provide() {
    return {
      open: this.open,
      close: this.close,
      toggle: this.toggle,
      closed: () => this.closed,
    }
  },
}
</script>
